export const authorizationRouter = [
    {
        path: '/registration',
        name: 'registration',
        component: () => import('../views/authorization/Registration.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/authorization/Login.vue')
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import('../views/authorization/Profile.vue'),
        meta: {
            requiresAuth: true
        }
    }
];
